import { isValidImportableFile, maxAssessmentFileSize } from '$synapse/core';
import { CandidateService } from '$synapse/services';
import { Component, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileService } from '../../../services/file.service';
import { SHARED_IMPORTS } from '../../../core/shared-imports';

@Component({
  selector: 'syn-candidates-import',
  templateUrl: './candidate-import.component.html',
  styleUrls: ['./candidate-import.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class CandidateImportComponent {
  private readonly groupId = inject(MAT_DIALOG_DATA);
  private readonly _fileService = inject(FileService);
  private readonly _candidatesService = inject(CandidateService);
  private readonly _modalDisplay =
    inject<MatDialogRef<CandidateImportComponent>>(MatDialogRef);
  private readonly _toastr = inject(ToastrService);

  candidatesFile: FileList = null;
  isSubmitOk = false;
  readonly title =
    'Importer des candidats dans le groupe depuis un fichier CSV';

  fileBrowseHandler(files: FileList) {
    this.candidatesFile = files;
    this._submitCheck();
  }

  formatBytes(bytes: number, decimals: number) {
    return this._fileService.formatBytes(bytes, decimals);
  }

  submit() {
    if (!this.isSubmitOk) {
      return;
    }
    this._upload();
  }

  private _submitCheck() {
    if (!this.candidatesFile) {
      return (this.isSubmitOk = false);
    }
    if (
      isValidImportableFile(
        this.candidatesFile,
        maxAssessmentFileSize,
        this._toastr
      )
    ) {
      return (this.isSubmitOk = false);
    }
    this.isSubmitOk = true;
  }

  private _upload() {
    this._candidatesService
      .uploadCandidates(this.groupId, this.candidatesFile)
      .subscribe(() => this._modalDisplay.close());
  }
}
